import { apiService } from './api';

export interface Question {
    questaoBaseId?: string;
    titulo: string;
    descricao: string;
    tipoBase: "KATRU" | "ENTIDADE";
    areaId: string;
    itemIds: number[];
}

// Define Item interface
export interface Item {
    id: number;
    name: string;
    description: string;
    actions: ItemAction[];
}

// Define ItemAction interface
export interface ItemAction {
    id: number;
    title: string;
    description: string;
}

// Define pagination parameters
export interface PaginationParams {
    page: number;
    size: number;
    titulo?: string;
    areaId?: string;
}

// Define paginated response
export interface PaginatedQuestionResponse {
    content: Question[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    first: boolean;
    last: boolean;
}

export const questionBaseService = {
    async getQuestions(params: PaginationParams): Promise<PaginatedQuestionResponse> {
        try {
            let url = `/questao-base?page=${params.page}&size=${params.size}`;

            if (params.titulo) {
                url += `&titulo=${encodeURIComponent(params.titulo)}`;
            }

            if (params.areaId) {
                url += `&areaId=${params.areaId}`;
            }

            const response = await apiService.get<PaginatedQuestionResponse>(url);
            return response;
        } catch (error) {
            console.error('Error fetching questions:', error);
            throw error;
        }
    },

    async getQuestionById(id: string): Promise<Question> {
        try {
            const response = await apiService.get<Question>(`/questao-base/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching question:', error);
            throw error;
        }
    },

    async createQuestion(question: Omit<Question, 'id'>): Promise<Question> {
        try {
            const response = await apiService.post<Question>('/questao-base', question);
            return response;
        } catch (error) {
            console.error('Error creating question:', error);
            throw error;
        }
    },

    async updateQuestion(id: any, question: Partial<Question>): Promise<Question> {
        try {
            const response = await apiService.put<Question>(`/questao-base/${id}`, question);
            return response;
        } catch (error) {
            console.error('Error updating question:', error);
            throw error;
        }
    },

    async deleteQuestion(questaoBaseId: string): Promise<void> {
        try {
            await apiService.delete(`/questao-base/${questaoBaseId}`);
        } catch (error) {
            console.error('Error deleting question:', error);
            throw error;
        }
    }
}; 